import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';

import { MerchantRegistrationModule } from '@authentication/modules/merchant-registration/merchant-registration.module';
import { MerchantUserRegistrationModule } from '@authentication/modules/merchant-user-registration/merchant-user-registration.module';
import { MerchantModule } from '@merchant/merchant.module';
import { SharedModule } from '@shared/shared.module';

import { PartnerBasicDataComponent } from './components/partner-basic-data/partner-basic-data.component';
import { PartnerRegistrationComponent } from './components/partner-registration/partner-registration.component';
import { PartnerSiteComponent } from './components/partner-site/partner-site.component';
import { PartnerUserRegistrationComponent } from './components/partner-user-registration/partner-user-registration.component';
import { TelesalesRoutingModule } from './telesales-routing.module';
import { TelesalesComponent } from './telesales/telesales.component';

@NgModule({
  declarations: [
    TelesalesComponent,
    PartnerRegistrationComponent,
    PartnerUserRegistrationComponent,
    PartnerBasicDataComponent,
    PartnerSiteComponent,
  ],
  imports: [
    CommonModule,
    TelesalesRoutingModule,
    SharedModule,
    MerchantRegistrationModule,
    MerchantUserRegistrationModule,
    MerchantModule,
  ],
})
export class TelesalesModule {}
